import React, { useCallback, useState } from 'react';
import Slider from 'rc-slider';
import cn from 'classnames';
import { CONSTANTS } from 'utils';
import { getSliderMarks } from 'components/base/helpers';

import './customSlider.styles.scss';

interface SliderProps {
	name: string;
	onChange?: (n: string, value: number) => void;
	onAfterChange?: (n: string, value: number) => void;
	defaultValue?: number | null;
	disabled?: boolean;
	wrapperClass?: string;
	leftLabel: string;
	rightLabel: string;
	value?: number | null;
}

const min = 1;

export const CustomSlider = ({
	onChange,
	onAfterChange,
	defaultValue,
	disabled,
	wrapperClass = '',
	leftLabel,
	rightLabel,
	name,
	value,
}: SliderProps) => {
	const rangeMiddleValue = CONSTANTS.defaultRangeMax / 2;

	const marks = getSliderMarks(leftLabel, rightLabel);
	const startValue = defaultValue || rangeMiddleValue;
	const isMiddleActive = value || startValue === rangeMiddleValue;
	const isRightActive = value || startValue > rangeMiddleValue;

	const [isSliderTouched, setIsSliderTouched] = useState(!!defaultValue);

	const handleChange = useCallback(
		(v: number) => {
			if (onChange) {
				onChange(name, v);
			}
		},
		[onChange, name],
	);

	const handleAfterChange = useCallback(
		(v: number) => {
			setIsSliderTouched(true);
			if (onAfterChange) {
				onAfterChange(name, v);
			}
		},
		[onAfterChange, name],
	);

	const props = {
		key: leftLabel,
		min,
		max: CONSTANTS.defaultRangeMax,
		marks,
		defaultValue: startValue,
		onChange: handleChange,
		onAfterChange: handleAfterChange,
		disabled,
		className: cn(wrapperClass, {
			untouchedSlider: !isSliderTouched,
			right: isRightActive,
			middle: isMiddleActive,
		}),
	};

	return (
		<>
			{value || value === null ? (
				<Slider value={value || rangeMiddleValue} {...props} />
			) : (
				<Slider {...props} />
			)}
		</>
	);
};
